import { render, staticRenderFns } from "./CallBack.vue?vue&type=template&id=ef6a902c&"
import script from "./CallBack.vue?vue&type=script&lang=js&"
export * from "./CallBack.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports